import Table from "../components/application-status/Table";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import SearchBar from "../components/application-status/SearchBar";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS, USER_TYPE } from "../configs/constants";
import { useCanIShowHook } from "../app/useCanIShowHook";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { stringToBoolean } from "../components/default-constants";
import { useAppDispatch } from "../app/hook";
import {
  INITIAL_SEARCH_CRITERIA,
  setSearchCriteria,
} from "../features/slices/application-status-list";
import { useHasAuthorityHook } from "../app/useHasAuthorityHook";

/**
 * 申請状況照会
 */
const ApplicationStatus = () => {
  const hasAuthority = useAuthenticationHook(PERMISSIONS.PROGRESS);
  const isDocomoUser = useCanIShowHook(USER_TYPE.DOCOMO);
  const isMerchantGenUser = useCanIShowHook(USER_TYPE.MERCHANT_GEN);
  const isApply = useHasAuthorityHook(PERMISSIONS.APPLY);
  const dispatch = useAppDispatch();
  const { pathname, search } = useLocation();
  const query = new URLSearchParams(search);
  const isBackFromDetail = stringToBoolean(query.get("isBackFromDetail"));
  const [skip, setSkip] = useState(false);

  useEffect(() => {
    if (!isBackFromDetail) {
      dispatch(setSearchCriteria(INITIAL_SEARCH_CRITERIA));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <SpaceBetween size="l">
      {hasAuthority && (
        <>
          <SearchBar
            isDocomoUser={isDocomoUser}
            isMerchantGenUser={isMerchantGenUser}
            isApply={isApply}
            setSkip={setSkip}
          />
          <Table
            isBackFromDetail={isBackFromDetail}
            isDocomoUser={isDocomoUser}
            isApply={isApply}
            skip={skip}
          />
        </>
      )}
    </SpaceBetween>
  );
};

export default ApplicationStatus;
